import { DinamikBilesen } from '@service/fikoyt-ui/decorators/dinamik-bilesen';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GameCardBase, GC_BASE_CSS } from '@/src/app/uygulamalar/hmi-pano/pano/game-card-base';
import { paramDeger } from '@/src/app/shared/utils/param-deger.utils';
import { FikoYTKokBilesenComponent } from '@/src/service/kok-bilesen/kok-bilesen.component';
import { CamMalzemeTanimiEditComponent } from './cam-malzeme-tanimi-edit.component';

@Component({
  selector: 'cam-malzeme-kart',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="gc gc--cam-malz" [style.--accent]="'#0e7490'" [style.--accent-rgb]="'14,116,144'" (mousemove)="mouseMove($event)" (mouseleave)="mouseLeave()" [ngStyle]="kartStil">
      <div class="gc-canli-bg"></div><div class="gc-parlak-kenar"></div>
      <div class="gc-kose gc-kose--sol-ust"></div><div class="gc-kose gc-kose--sag-ust"></div><div class="gc-kose gc-kose--sol-alt"></div><div class="gc-kose gc-kose--sag-alt"></div>
      <div class="gc-kose-ic gc-kose-ic--sol-ust"></div><div class="gc-kose-ic gc-kose-ic--sag-ust"></div><div class="gc-kose-ic gc-kose-ic--sol-alt"></div><div class="gc-kose-ic gc-kose-ic--sag-alt"></div>
      <div class="gc-rarity-serit"></div><div class="gc-ic-glow"></div><div class="gc-desen"></div><div class="gc-shimmer"></div><div class="gc-holo"></div>
      <div class="gc-kenar-glow" [style.background]="kenarGlow"></div>
      <div class="gc-icerik">
        <div class="gc-hud-baslik">🧊 MALZEME</div>
        <div class="cm-baslik">{{ d('malzemeAdi') || 'İsimsiz Malzeme' }}</div>
        @if (d('pilesmi')) { <div class="cm-alt">{{ d('pilesmi') }}</div> }
        <div class="cm-detay">
          @if (d('kalinlik')) { <span>{{ d('kalinlik') }} mm</span> }
          @if (d('renk')) { <span>{{ d('renk') }}</span> }
        </div>
        @if (d('stokMiktari')) {
          <div class="cm-stok" [style.color]="stokRenk()">{{ stokEtiket() }}</div>
        }
        <div class="gc-xp-bar"><div class="gc-xp-dolgu" [style.width.%]="gorunur() ? 50 : 0"></div></div>
      </div>
    </div>
  `,
  styles: [GC_BASE_CSS, `
    .cm-baslik { font-size: 14px; font-weight: 700; color: var(--py-metin, #e2e8f0); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
    .cm-alt { font-size: 11px; color: var(--py-metin-ikincil, #94a3b8); }
    .cm-detay { display:flex; gap:8px; font-size: 10px; color: var(--py-metin-ucuncul, #64748b); font-family: monospace; }
    .cm-stok { font-size:10px; color:#22c55e; font-weight:600; margin-top:2px; }
  `],
})
export class CamMalzemeKartComponent extends GameCardBase {
  parametreler = input<any>();
  constructor() { super(); }
  d(ismi: string) { return paramDeger(this.parametreler()?.ek, ismi); }
  stokRenk = computed(() => {
    const stok = +(this.d('stokMiktari') || 0);
    const min = +(this.d('minimumStok') || 0);
    if (min && stok <= min * 0.5) return '#ff4d4f';
    if (min && stok <= min) return '#faad14';
    return '#22c55e';
  });
  stokEtiket = computed(() => {
    const stok = +(this.d('stokMiktari') || 0);
    const min = +(this.d('minimumStok') || 0);
    if (min && stok <= min * 0.5) return `⛔ Stok: ${stok} (KRİTİK)`;
    if (min && stok <= min) return `⚠️ Stok: ${stok} (Az)`;
    return `Stok: ${stok}`;
  });
}

@Component({
  selector: 'cam-malzeme-kart-sade',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="sk" style="--sk-accent:#0e7490">
      <div class="sk-icerik">
        <div class="sk-baslik">🧊 {{ d('malzemeAdi') || 'İsimsiz Malzeme' }}</div>
        <div class="sk-alt">
          @if (d('pilesmi')) { <span>{{ d('pilesmi') }}</span> }
          @if (d('kalinlik')) { <span> · {{ d('kalinlik') }} mm</span> }
          @if (d('renk')) { <span> · {{ d('renk') }}</span> }
        </div>
      </div>
      <div class="sk-sag">
        @if (d('stokMiktari')) { <span style="font-size:12px;font-weight:600;color:var(--py-metin,#333)">{{ d('stokMiktari') }} ad.</span> }
      </div>
    </div>
  `,
})
export class CamMalzemeKartSadeComponent extends FikoYTKokBilesenComponent {
  parametreler = input<any>();
  constructor() { super(); }
  p = computed(() => this.parametreler()?.ek || {});
  d(alan: string): any { return paramDeger(this.p(), alan); }
}

@DinamikBilesen({
  id: 'cam-malzeme-tanimi',
  baslik: 'Malzeme Tanımı',
  aciklama: 'Cam malzeme tanımı',
  ikon: 'experiment',
  kategori: 'cam-isleme',
})
class CamMalzemeTanimi {
  paylas_kutusu = CamMalzemeTanimiEditComponent;
  paylasilmis_kart = CamMalzemeKartComponent;
  paylasilmis_kart_sade = CamMalzemeKartSadeComponent;
}
